<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {getAllActiveByFilter, getAllActiveCount} from 'src/components/cabinet/#services/memberships'
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import arrow from 'src/components/cabinet/#assets/arrow.png'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import IconifyIcon from '@iconify/svelte'
    import yesIcon from '@iconify/icons-fa-solid/check-square'
    import noIcon from '@iconify/icons-fa-solid/square'

    let classAppDropdownOpen = false
    let classDropdownMembershipOpen = false
    let classSubscriptionDropdownOpen = false
    let selectedMembership
    let selectedApp
    let isSubscription
    let currentPage = 0
    let perPage = 25
    let apps = {
        3: 'Crypto Cats',
        5: 'Crypto Dragons (Android)',
        6: 'Crypto Dragons (iOS)',
        7: 'Crypto Fox',
        9: 'Battler',
        11: 'Crypto DOGE',
        13: 'Elon Game',
        15: 'Crypto Pepe'
    }

    function changeMembership(membershipName) {
        currentPage = 0
        if (membershipName == 'all') {
            selectedMembership = undefined
        } else {
            selectedMembership = membershipName
        }
    }

    function changeApp(appId) {
        currentPage = 0
        if (appId == 'all') {
            selectedApp = undefined
        } else {
            selectedApp = appId
        }
    }

    function changeSubscription(status) {
        currentPage = 0
        if (status == 'all') {
            isSubscription = undefined
        } else {
            isSubscription = status
        }
    }

    function filter() {
        getAllActiveCount.reset()
        getAllActiveByFilter.reset()
        getAllActiveCount.send()
        getAllActiveByFilter.send({ data: {
            page:currentPage + 1,
            perPage,
            appId: selectedApp,
            membership: selectedMembership,
            isSubscription
        }})
        $getAllActiveByFilter.value
    }

    function reset() {
        selectedApp = undefined
        selectedMembership = undefined
        isSubscription = undefined
        currentPage = 0
        filter()
    }

    $:currentPage,perPage,filter()
</script>

<svelte:head>
    <title>Membership Owners</title>
</svelte:head>

<MainLayout title="Membership Owners">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                {#if !$getAllActiveCount.hasValue && $getAllActiveCount.loading}
                    <p>Loading...</p>
                {:else if !$getAllActiveCount.hasValue && $getAllActiveCount.error }
                    <p>Something went wrong. Try refreshing the page.</p>
                {:else if $getAllActiveCount.value}
                    <div class="d-flex mb-3">
                        {#each $getAllActiveCount.value as {membership, count}}
                            <div class="count-card">
                                <div class="count">{count}</div>
                                {membership}
                            </div>
                        {/each}
                    </div>
                {/if}
                <div class="buttons">
                    <div class="pc-line">
                        <div class="dropdown" use:clickOutside={() => {classDropdownMembershipOpen = false}} class:active={classDropdownMembershipOpen}>
                            <div class="dropdown-selected">
                                <div class="need-select" on:click={() => {classDropdownMembershipOpen = !classDropdownMembershipOpen}}>
                                    Choose a membership<img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="dropdown-list">
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeMembership('all')} checked={!selectedMembership} disabled={!selectedMembership}>All
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeMembership('silver')} checked={selectedMembership === 'silver'}>Silver
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeMembership('gold')} checked={selectedMembership === 'gold'}>Gold
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeMembership('platinum')} checked={selectedMembership === 'platinum'}>Platinum
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="pc-line">
                        <div class="dropdown" use:clickOutside={() => {classAppDropdownOpen = false}} class:active={classAppDropdownOpen}>
                            <div class="dropdown-selected">
                                <div class="need-select" on:click={() => {classAppDropdownOpen = !classAppDropdownOpen}}>
                                    Choose a game<img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="dropdown-list">
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp('all')} checked={!selectedApp} disabled={!selectedApp}>All
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(3)} checked={selectedApp === 3}>Crypto Cats
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(5)} checked={selectedApp === 5}>Dragons (Android)
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(6)} checked={selectedApp === 6}>Dragons (IOS)
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(7)} checked={selectedApp === 7}>Crypto Fox
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(11)} checked={selectedApp === 11}>Crypto DOGE
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(13)} checked={selectedApp === 13}>Elon Game
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeApp(15)} checked={selectedApp === 15}>Crypto Pepe
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="pc-line">
                        <div class="dropdown" use:clickOutside={() => {classSubscriptionDropdownOpen = false}} class:active={classSubscriptionDropdownOpen}>
                            <div class="dropdown-selected">
                                <div class="need-select" on:click={() => {classSubscriptionDropdownOpen = !classSubscriptionDropdownOpen}}>
                                    Is subscription<img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="dropdown-list">
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeSubscription('all')} checked={isSubscription === undefined}>All
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeSubscription(true)} checked={isSubscription === true}>Yes
                                </label>
                                <label class="checkbox">
                                    <input type="checkbox" on:click={() => changeSubscription(false)} checked={isSubscription === false}>No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="pc-line">
                        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
                        <button class="btn btn-secondary mr-2" on:click={reset}>Reset</button>
                        {#if $getAllActiveByFilter.loading}
                            Loading...
                        {:else if $getAllActiveByFilter.error || !$getAllActiveByFilter.hasValue}
                            Error
                        {:else if $getAllActiveByFilter.hasValue}
                            (Total: {$getAllActiveByFilter.value.totalCount})
                        {/if}
                    </div>
                </div>
                {#if $getAllActiveByFilter.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$getAllActiveByFilter.loading || $getAllActiveByFilter.loading}
                        totalCount={$getAllActiveByFilter.value.totalCount}
                    />
                {/if}
                <div class="transactions-list">
                    <Table bordered striped responsive>
                        <thead>
                            <tr>
                                <td class="text-center">User</td>
                                <td class="text-center">Game</td>
                                <td class="text-center">Membership</td>
                                <td class="text-center">Subscription</td>
                            </tr>
                        </thead>
                        <tbody>
                        {#if $getAllActiveByFilter.loading}
                            <tr>
                                <td><span class="loading transaction-loading"></span></td>
                                <td><span class="loading transaction-loading"></span></td>
                                <td><span class="loading transaction-loading"></span></td>
                                <td><span class="loading transaction-loading"></span></td>
                            </tr>
                        {:else if $getAllActiveByFilter.error || !$getAllActiveByFilter.hasValue}
                            <tr>
                                <td class="text-center" colspan="4">
                                    {#if $getAllActiveByFilter.error}
                                        {$getAllActiveByFilter.error}
                                    {:else}
                                        Something went wrong. Try refreshing the page.
                                    {/if}
                                </td>
                            </tr>
                        {:else}
                            {#each $getAllActiveByFilter.value.data as {userId, appId, membership, isSubscription}}
                                <tr>
                                    <td class="text-center">
                                        <a href="profile/{userId}" class="reason" target="_blank">{userId}</a>
                                    </td>
                                    <td class="text-center">{apps[appId]}</td>
                                    <td class="text-center camelcase">{membership}</td>
                                    <td class="text-center">
                                        {#if isSubscription}
                                            <IconifyIcon icon={yesIcon}/>
                                        {:else}
                                            <IconifyIcon icon={noIcon}/>
                                        {/if}
                                    </td>
                                </tr>
                            {:else}
                                <tr>
                                    <td class="text-center" colspan="4">No items</td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                    {#if $getAllActiveByFilter.hasValue}
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$getAllActiveByFilter.value.totalCount}
                            {perPage}
                            disabled={$getAllActiveByFilter.loading || $getAllActiveByFilter.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .camelcase {
        text-transform: capitalize;
    }

    .mr-2 {
        margin-right: 10px;
    }

    .count-card {
        background: #f2f2f2;
        border-radius: 8px;
        margin-right: 10px;
        width: 140px;
        padding: 15px 15px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        text-align: center;
        border: 1px solid #dee2e6;
        text-transform: capitalize;
    }

    .count {
        font-weight: 500;
        font-size: 23px;
        width: 100%;
        line-height: 25px;
    }

    .buttons {
        margin-bottom: 15px;
    }

    .user-ids-col {
        max-width: 600px;
    }

    .text-right {
        text-align: right;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .pc-line {
        display: inline-block;
        vertical-align: top;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .date-label {
        padding: 0 5px;
        line-height: 38px;
    }

    .form-select, .form-control {
        width: auto;
        display: inline-block;
        vertical-align: top;
        width: 300px;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .dropdown {
        background: white;
        width: 220px;
        border-radius: 3px;
        position: relative;
        display: inline-block;
        z-index: 3;
        border: 1px solid #ced4da;
    }

    .dropdown.sort-by-dropdown {
        width: 180px;
    }

    .dropdown-selected {
        padding: 10px;
        font-size: 14px;
        color: #212529;
        font-weight: 300;
        position: relative;
        cursor: pointer;
        user-select: none;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 11px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
        filter: invert(1);
        opacity: 0.8;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 6px 15px;
        height: 36px;
        margin: -10px;
        font-size: 1rem;
    }

    .dropdown-list {
        display: none;
        padding: 12px;
        position: absolute;
        background: white;
        width: 100%;
        border-radius: 3px;
        margin-top: 10px;
        border: 1px solid #ced4da;
        z-index: 2;
        box-shadow: 0 2px 5px 0 #0a0a0a2e;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .checkbox,
    .dropdown-list .item {
        font-size: 16px;
        color: #212529;
        font-weight: 400;
        padding: 3px 0;
        display: block;
        cursor: pointer;
        user-select: none;
        transition: .25s;
    }

    .dropdown-list .checkbox:hover,
    .dropdown-list .item:hover {
        color: #212529;
    }

    .dropdown-list .checkbox:last-child,
    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    .checkbox input[type="checkbox"] {
        width: 1em;
        height: 1em;
        margin-top: 3px;
        vertical-align: top;
        margin-right: 10px;
        background: none;
        border-radius: 2px;
        border: 1px solid #A0AEC0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }

    .checkbox input[type="checkbox"]:checked {
        background-color: #FF5D1C;
        border-color: #FF5D1C;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    .form-select {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .date-label {
        padding: 0 5px;
        line-height: 38px;
        font-weight: 500;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
        vertical-align: top;
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    .form-select {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }



    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }
    }
</style>
